<template>
  <div :class="{ 'show-filter': show }" class="select_tpl">
    <!--:class="'show-filter': show"-->
    <!--<hr class="hr">-->
    <div @keyup.prevent="keyNav" class="extra-filter">
      <div @click="toggleDropdown" class="extra-filter-title">
        <span class="extra-filter-title-name">{{ title }}</span>
        <div>
          <span v-if="getCount"
                class="extra-filter-title-counter">{{ getCount }}</span>
          <svg :class="{ active: show }"
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 16 9"
               width="16px"
               height="9px">
            <path fill="#18232C"
                  fill-rule="nonzero"
                  d="M0 .77145L.750022 0 8 7.4571 15.249978 0 16 .77145 8 9z"/>
          </svg>
        </div>
      </div>
      <div v-if="show" class="extra-filter-content">
        <div v-if="$device.mobile()" class="extra-filter-content-tags">
          <div v-for="(sel, index) in sel"
               :key="index"
               class="extra-filter-content-tag"
               @click="unSelectFilter(sel.id, sel.filter_name)"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 13 13"
                width="10px"
                height="10px">
              <g fill="#000" fill-rule="evenodd">
                <path d="M1e-8 11.31370847L11.31370851-3e-8l1.41421356 1.41421356-11.3137085 11.3137085z"
                />
                <path d="M1.41421353 1e-8l11.3137085 11.3137085-1.41421356 1.41421356L-3e-8 1.41421357z"
                />
              </g>
            </svg>

            <span style="white-space: nowrap;">{{ sel.name }}</span>
          </div>
        </div>
        <input ref="filter"
               v-focus
               type="search"
               class="extra-filter-content-search"
               v-model="s"/>
        <div class="extra-filter-content-wrap">
          <label v-for="(d, index) in menuItems()"
                 :key="index"
                 :for="filter_name + '_' + d.id"
                 v-show="!d.hide"
                 :class="['checkbox-filter-label',{active: selectedItem !== null && selectedItem == index, 'group-label': d.isLabel, 'sub-item': d.model_class || d.bid }]"
                 style="width: 100%;">
            <input v-if="d.disable != '1' && !d.isLabel"
                   type="checkbox"
                   :id="filter_name + '_' + d.id"
                   :value="d.id"
                   v-model="filters[d.filter_name?d.filter_name:filter_name]"/>
            <span v-if="d.disable != '1' && !d.isLabel" class="checkmark"></span>
            <span class="checkbox-filter-hint">{{ d.name }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import f from "../helpers/func";
import {mapGetters, mapState} from "vuex";

export default {
  data() {
    return {
      show: false,
      s: "",
      sel: [],
      dropDownData: [],
      selectedItem: null,
      menuLength: 20,
      loadItems: {}
    };
  },
  props: ["title", "data", "filters", "filter_name", "url", "allFiltersNames"],
  methods: {
    toggleDropdown() {
      this.show = !this.show

      this.$nextTick(() => {
        if (this.show) {
          if (!window.matchMedia(`(max-width: 768px)`).matches) {
            this.$refs.filter.focus()
          }

          if (this.$el.querySelector('.extra-filter-content-wrap')) this.$el.querySelector('.extra-filter-content-wrap').addEventListener('scroll', this.handleScroll);
        } else {
          this.menuLength = 20
        }

        let scrollingElement = ''
        if (this.$device.tablet()) {
          scrollingElement = 'html'
        } else if (this.$device.ios() && this.$store.state.isApp) {
          scrollingElement = document.querySelector('.page-dealers-cars') ? '.page-dealers-cars.show-menu' : '.page-old-cars.show-menu'
        } else {
          scrollingElement = document.querySelector('.page-dealers-cars') ? '.filters.dealers' : '.filters.filters-old-cars'
        }

        const elBounding = this.$el.getBoundingClientRect()
        const contHeight = scrollingElement === 'html' ? document.querySelector(scrollingElement).clientHeight : document.querySelector(scrollingElement).offsetHeight

        if (elBounding.height + elBounding.top + (this.$device.mobile() ? 100 : 0) > contHeight) {
          document.querySelector(scrollingElement).scrollTop += elBounding.top - 74
        }
      })
    },
    unSelectFilter(id, filterName) {
      if (this.filter_name === 'all_filters') {
        this.allFiltersNames.forEach(name => {
            if (this.filters[name].includes(id) || this.filters[name].includes(id.toString())) {
              this.filters[name].splice(this.filters[name].indexOf(f.findInArr(this.sel, id, true, null, filterName).id), 1);
            }
        })
      } else {
        this.filters[this.filter_name].splice(f.findInArr(this.sel, id), 1);
      }
    },
    getFinedItem() {
      /*if (this.url) {
        return this.dropDownData;
      }*/
      let res = [];
      let d = this.dropDownData;
      for (let k in d) {
        if (!d[k].hide) res.push(d[k]);
      }
      return res;
    },
    getOtherSelected() {
      let sel = [];
      let fil = [];
      if (this.filter_name === 'all_filters') {
        this.allFiltersNames.forEach(name => {
          if (this.filters[name] && this.filters[name].length) fil.push({filterName: name, ids: this.filters[name]})
        })

        fil.forEach(filter => {
          for (let k in filter.ids) {
            let item = filter.ids[k];
            if (f.findInArr(this.data, item, true, null, filter.filterName) && !f.findInArr(sel, item, null, null, filter.filterName)) {
              sel.push(f.findInArr(this.data, item, true, null, filter.filterName));
            }
          }
        })
      } else {
        fil = this.filters[this.filter_name];

        for (let k in fil) {
          let item = fil[k];
          if (f.findInArr(this.data, item, true) && !f.findInArr(sel, item)) {
            sel.push(f.findInArr(this.data, item, true));
          }
        }
      }

      this.sel = sel;
    },
    setFilter() {
      /*if (this.url) {
        this.$http
            .post(
                this.url + "?q=" + this.s,
                {filters: this.$store.state.dealerFilterData},
                {
                  before(request) {
                    if (this.previousRequest) {
                      this.previousRequest.abort();
                    }
                    this.previousRequest = request;
                  }
                }
            )
            .then(response => {
              if (response.body.res) {
                this.dropDownData = response.body.res;
              } else {
                this.dropDownData = [{id: 0, name: "none", disable: true}];
              }
            });*/
      //} else {
      let d = this.dropDownData;
      let findItem = [];
      for (let k in d) {
        let item = d[k];
        if (
            typeof item.name == "string" &&
            item.name.toLocaleLowerCase().includes(this.s.toLocaleLowerCase())
        ) {
          item.hide = false;
          findItem.push(item);
        } else {
          item.hide = true;
        }
      }

      if (findItem.length == 1) {
        if (
            findItem[0].name.toLocaleLowerCase() == this.s.toLocaleLowerCase()
        ) {
          if (this.filter_name === 'all_filters') {
            if (this.filters[findItem[0].filter_name].indexOf(findItem[0].id) == -1) {
              this.filters[findItem[0].filter_name].push(findItem[0].id);
            }
          } else if (this.filters[this.filter_name].indexOf(findItem[0].id) == -1) {
            this.filters[this.filter_name].push(findItem[0].id);
          }
        }
      }
      //}
    },
    keyNav(e) {
      if (
          e.keyCode == 40 &&
          (this.selectedItem === null ||
              this.selectedItem <
              (this.getFinedItem().length > 0
                  ? this.getFinedItem().length
                  : this.dropDownData.length) -
              1)
      ) {
        //press down
        this.selectedItem === null
            ? (this.selectedItem = 0)
            : this.selectedItem++;
      } else if (e.keyCode == 38 && this.selectedItem > 0) {
        //press up
        this.selectedItem === null
            ? (this.selectedItem = 0)
            : this.selectedItem--;
      } else if (e.keyCode == 13) {
        //press enter
        document.querySelector(".checkbox-filter-label.active").click();
        this.selectedItem = null;
        this.$refs.filter.focus();
      }

      let elem = document.querySelector(".checkbox-filter-label.active");
      if (elem) {
        document
            .querySelector(".extra-filter-content-wrap")
            .scroll(0, this.selectedItem * elem.offsetHeight - 100);
      }
    },
    handleScroll() {
      const menuContainer = this.$el.querySelector('.extra-filter-content-wrap')
      if (
        menuContainer.scrollHeight - menuContainer.scrollTop - menuContainer.clientHeight > -1 &&
        menuContainer.scrollHeight - menuContainer.scrollTop - menuContainer.clientHeight < 1
      ) {
        this.menuLength += 20
      }
    },
    menuItems() {
      return (this.getFinedItem().length > 0 ? this.getFinedItem() : this.dropDownData).slice(0, this.menuLength)
    },
    /*loadDataFromUrl() {
      if (this.url) {
        console.log("Lib",this.lib.aukahlutir)
        const url = this.api + this.url;
        this.$http
            .get(url)
            .then(response => {
              if (response.body.res) {
                if (this.filter_name === 'all_filters') {
                  this.$emit('dropdown-data-from-url', response.body.res)
                } else {
                  console.log('response.body.res',response.body.res);
                  this.dropDownData = response.body.res;
                  this.loadItems = response.body.res;
                }
              } else {
                if (this.filter_name !== 'all_filters') this.dropDownData = [{id: 0, name: "none", disable: true}];
              }
            });
      }
    }*/
  },
  mounted() {
    this.getOtherSelected();
  },
  computed: {
    ...mapGetters({lib: 'LIB'}),
    ...mapState({
      api: (state) => state.api
    }),
    getCount() {
      if (this.filter_name == 'other') {
        let arr = [];
        let cur_filter = this.filters[this.filter_name];
        cur_filter = cur_filter.concat(this.filters['drif'])
        for (let k in this.data) {
          let item = this.data[k];
          if (cur_filter.indexOf(item.id) >= 0) {
            arr.push(item);
          }
        }
        return arr.length > 0 ? arr.length : null;
      } else if (this.filter_name === 'all_filters') {
        let count = 0;
        this.allFiltersNames.forEach(name => {
          count += this.filters[name] ? this.filters[name].length : 0
        })
        return count
      }
      return this.filters[this.filter_name] && this.filters[this.filter_name].length;
    }
  },
  watch: {
    dropDownData() {
      if (!this.url || this.filter_name === 'all_filters') {
        if (this.show && this.s.length > 0) {
          this.setFilter();
        }
      }
    },
    s() {
      this.selectedItem = null;
      this.menuLength = 20;
      this.setFilter();
    },
    filters: {
      handler() {
        if(this.filter_name === 'aukahlutir'){
          //console.log(this.filters[this.filter_name])
        }
        let th = this;
        if (this.getFinedItem().length == 1) {
          setTimeout(function () {
            th.s = "";
          }, 100);
        }
        th.getOtherSelected();
      },
      deep: true
    },
    show() {
      /* Visibility switching checkbox list */
      this.show && (!this.url || this.filter_name === 'all_filters') ? (this.dropDownData = this.data) : (this.s = "");

      /*
      if (this.show && this.url) {
        this.loadDataFromUrl();
      }*/
    },
    sel() {
      /* Check selected brands */
      let flag = this.sel.length === 0 ? true : false;
      this.$emit("selectedBrands", flag);
    },
    data() {
      if (!this.url || this.filter_name === 'all_filters') this.dropDownData = this.data;
    }
  },
  directives: {
    focus: {
      inserted(el) {
        if (device.desktop()) el.focus();
      }
    }
  }
};
</script>
